import React from 'react';

import AddRoundedIcon from '@mui/icons-material/AddRounded';
import RemoveRoundedIcon from '@mui/icons-material/RemoveRounded';

import classes from './SidebarSolutionSection.module.scss';
import { SidebarItem } from '../../components/SidebarItem/SidebarItem';
import { SolutionItemList } from './SolutionItemList/SolutionItemList';
import { SolutionItem } from '../../../../interfaces/system/SidebarNavConfig';
import { getNavigationIcon } from '../../../../utils/navigationUtils/getNavigationIcon/getNavigationIcon';
import { useSidebarContext } from '../../hooks/SidebarContext';

type SidebarSolutionSectionProps = {
  item: SolutionItem;
  isExpanded: boolean;
  onToggle: () => void;
};

const SidebarSolutionSection = ({
  item,
  isExpanded,
  onToggle,
}: SidebarSolutionSectionProps) => {
  const { icon, label, items: groups } = item;
  const { isCollapsed } = useSidebarContext();

  return (
    <div className={classes.section}>
      <SidebarItem
        as="button"
        size="medium"
        onClick={onToggle}
        startIcon={getNavigationIcon(icon)}
        label={label}
        endIcon={isExpanded ? <RemoveRoundedIcon /> : <AddRoundedIcon />}
        active={isExpanded}
        collapsed={isCollapsed}
      />
      {isExpanded && <SolutionItemList groups={groups} />}
    </div>
  );
};

export { SidebarSolutionSection };
